module.exports = __webpack_public_path__ + "img/companyCount1.png";